import { render, staticRenderFns } from "./TwitchReplay.vue?vue&type=template&id=0e918996&scoped=true&"
import script from "./TwitchReplay.vue?vue&type=script&lang=js&"
export * from "./TwitchReplay.vue?vue&type=script&lang=js&"
import style0 from "./TwitchReplay.vue?vue&type=style&index=0&id=0e918996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e918996",
  null
  
)

export default component.exports